import { useEffect } from "react";

interface UseClampPageIndexOptions {
  pageIndex: number;
  pageCount: number;
  onClamp: (newPageIndex: number) => void;
}

export function useClampPageIndex({ pageIndex, pageCount, onClamp }: UseClampPageIndexOptions) {
  useEffect(() => {
    if (pageCount > 0 && pageIndex > pageCount - 1) {
      onClamp(pageCount - 1);
    }
  }, [pageIndex, pageCount, onClamp]);
}
